

export const Paginate = (totalPages, currentPage, setPage) => {
    return () => {
        let pages = [];
        const maxPages = 10;

        if (totalPages <= maxPages) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            let startPage = Math.max(1, currentPage - Math.floor(maxPages / 2));
            let endPage = Math.min(totalPages, startPage + maxPages - 1);

            if (startPage > 1) {
                pages.push(1);
                if (startPage > 2) pages.push("...");
            }

            for (let i = startPage; i <= endPage; i++) {
                pages.push(i);
            }

            if (endPage < totalPages) {
                if (endPage < totalPages - 1) pages.push("...");
                pages.push(totalPages);
            }
        }

        return pages.map((page, index) => (
            typeof page === "number" ? (
                <button
                    key={index}
                    onClick={() => setPage(page)}
                    className={`page-number ${currentPage === page ? "active" : ""}`}
                    aria-label={`Go to page ${page}`}
                >
                    {page}
                </button>
            ) : (
                <span key={index} className="ellipsis">...</span>
            )
        ));
    };
}
